import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ES locales
import esCommon from './locales/es/common.json';
import esNavigation from './locales/es/navigation.json';
import esLanding from './locales/es/landing.json';
import esOnboarding from './locales/es/onboarding.json';
import esDashboard from './locales/es/dashboard.json';
import esDashboardV2 from './locales/es/dashboardV2.json';
import esStats from './locales/es/stats.json';
import esRankings from './locales/es/rankings.json';
import esMatches from './locales/es/matches.json';
import esScouting from './locales/es/scouting.json';
import esLiveTag from './locales/es/liveTag.json';
import esAdmin from './locales/es/admin.json';
import esLicenses from './locales/es/licenses.json';
import esPlayers from './locales/es/players.json';
import esTeams from './locales/es/teams.json';
import esClassifications from './locales/es/classifications.json';
import esTools from './locales/es/tools.json';
import esReports from './locales/es/reports.json';
import esAnalysis from './locales/es/analysis.json';
import esChat from './locales/es/chat.json';
import esPlanning from './locales/es/planning.json';
import esWindowsClient from './locales/es/windowsClient.json';
import esReferees from './locales/es/referees.json';
import esDirectories from './locales/es/directories.json';
import esAuth from './locales/es/auth.json';
import esAdvanced from './locales/es/advanced.json';
import esTutorials from './locales/es/tutorials.json';

// EN locales
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enLanding from './locales/en/landing.json';
import enOnboarding from './locales/en/onboarding.json';
import enDashboard from './locales/en/dashboard.json';
import enDashboardV2 from './locales/en/dashboardV2.json';
import enStats from './locales/en/stats.json';
import enRankings from './locales/en/rankings.json';
import enMatches from './locales/en/matches.json';
import enScouting from './locales/en/scouting.json';
import enLiveTag from './locales/en/liveTag.json';
import enAdmin from './locales/en/admin.json';
import enLicenses from './locales/en/licenses.json';
import enPlayers from './locales/en/players.json';
import enTeams from './locales/en/teams.json';
import enClassifications from './locales/en/classifications.json';
import enTools from './locales/en/tools.json';
import enReports from './locales/en/reports.json';
import enAnalysis from './locales/en/analysis.json';
import enChat from './locales/en/chat.json';
import enPlanning from './locales/en/planning.json';
import enWindowsClient from './locales/en/windowsClient.json';
import enReferees from './locales/en/referees.json';
import enDirectories from './locales/en/directories.json';
import enAuth from './locales/en/auth.json';
import enAdvanced from './locales/en/advanced.json';
import enTutorials from './locales/en/tutorials.json';
import esTactical from './locales/es/tactical.json';
import enTactical from './locales/en/tactical.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        tactical: esTactical,
        common: esCommon,
        navigation: esNavigation,
        landing: esLanding,
        onboarding: esOnboarding,
        dashboard: esDashboard,
        dashboardV2: esDashboardV2,
        stats: esStats,
        rankings: esRankings,
        matches: esMatches,
        scouting: esScouting,
        liveTag: esLiveTag,
        admin: esAdmin,
        licenses: esLicenses,
        players: esPlayers,
        teams: esTeams,
        classifications: esClassifications,
        tools: esTools,
        reports: esReports,
        analysis: esAnalysis,
        chat: esChat,
        planning: esPlanning,
        windowsClient: esWindowsClient,
        referees: esReferees,
        directories: esDirectories,
        auth: esAuth,
        advanced: esAdvanced,
        tutorials: esTutorials,
      },
      en: {
        tactical: enTactical,
        common: enCommon,
        navigation: enNavigation,
        landing: enLanding,
        onboarding: enOnboarding,
        dashboard: enDashboard,
        dashboardV2: enDashboardV2,
        stats: enStats,
        rankings: enRankings,
        matches: enMatches,
        scouting: enScouting,
        liveTag: enLiveTag,
        admin: enAdmin,
        licenses: enLicenses,
        players: enPlayers,
        teams: enTeams,
        classifications: enClassifications,
        tools: enTools,
        reports: enReports,
        analysis: enAnalysis,
        chat: enChat,
        planning: enPlanning,
        windowsClient: enWindowsClient,
        referees: enReferees,
        directories: enDirectories,
        auth: enAuth,
        advanced: enAdvanced,
        tutorials: enTutorials,
      },
    },
    lng: undefined,
    fallbackLng: 'es',
    defaultNS: 'common',
    supportedLngs: ['es', 'en'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
